import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();
  const periodTypeOptions = useSelector((state) => state.onDemandRevenue.periodTypeOptions);
  const periodType = useSelector((state) => state.onDemandRevenue.selectedFilters.periodType);

  const handleUpdatePeriodType = (data) => {
    dispatch(actionCreators.updateSelectedFilters({ periodType: data }));
  };

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={periodType}
      includeFilter={false}
      onSelectChange={handleUpdatePeriodType}
    />
  );
};

export default PeriodType;
